import type { TOC } from '@ember/component/template-only';

import styles from './td-month.module.css';

export interface MarketSnapshotsTableTdMonthSignature {
  Args: {
    cellData?: string;
    row: { isCurrentMonth?: boolean };
  };
}

const MarketSnapshotsTableTdMonth: TOC<MarketSnapshotsTableTdMonthSignature> =
  <template>
    <div class="truncate" title={{@cellData}}>
      {{#if @row.isCurrentMonth}}
        <span
          aria-current="date"
          class="{{styles.current-month}} text-200--bold"
          data-test-id="current-month"
        >{{@cellData}}</span>
      {{else}}
        {{@cellData}}
      {{/if}}
    </div>
  </template>;

export default MarketSnapshotsTableTdMonth;
